import { ReactElement } from "react";

function RawLayout({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

export default RawLayout;

export function getRawLayout(page: ReactElement) {
  return <RawLayout>{page}</RawLayout>;
}
